import { FLButton } from '@shared/ui';
import { useInvoiceGeneration } from './hooks';
import {
  activeButtonStyle,
  buttonContainerStyle,
  inactiveButtonStyle,
  menuStyle,
} from './InvoiceGeneratorMenu.tailwind';
import { MenuHeader } from './components';
import { ExcelFiles } from '../excel-files';
import { Templates } from '../templates';
import GenerationProgress from './GenerationProgress';
import { ToggleButton } from './components/toggle-button';
import { DownloadInvoicesButton } from '@widgets/download-invoices-button/DownloadInvoicesButton';
import { useAppDispatch, useAppSelector } from '@shared/model';
import { setIsGeneratorMenuOpen } from './model';
import { setGenerationIsTimedOut } from '@pages/invoice-generator/shared/model';

export const STATUSES = ['success', 'error'];

const InvoiceGeneratorMenu = () => {
  const { isReadyForGeneration, beginGenerationAsync, text } = useInvoiceGeneration();
  const dispatch = useAppDispatch();
  const isMenuOpen = useAppSelector(state => state.invoiceGeneratorMenu.isMenuOpen);

  const toggleMenu = () => {
    dispatch(setIsGeneratorMenuOpen(!isMenuOpen));
  };

  const buttonClasses = {
    container: isReadyForGeneration ? activeButtonStyle : inactiveButtonStyle,
  };

  const handleGenerate = async () => {
    dispatch(setGenerationIsTimedOut(false));
    await beginGenerationAsync();
  };

  return (
    <>
      <div className={menuStyle}>
        <MenuHeader />

        <ToggleButton isExpanded={isMenuOpen} onClink={toggleMenu}>
          <div className="flex flex-col">
            <Templates />
            <ExcelFiles />
          </div>

          <div className={buttonContainerStyle}>
            <DownloadInvoicesButton />
            <FLButton
              type="primary"
              onClick={handleGenerate}
              classes={buttonClasses}
              text={text}
              disabled={!isReadyForGeneration}
              data-id={`button-Generate${isReadyForGeneration ? 'Enabled' : 'Disabled'}`}
            />
          </div>
        </ToggleButton>
      </div>

      <GenerationProgress />
    </>
  );
};

export default InvoiceGeneratorMenu;
